import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import { createRequestCacheKey, fetchWithCache } from '../helpers/requestCache';

const STUDENTS_LIST_TTL_MS = 10 * 60 * 1000;

const studentsListCacheKey = (classId) => createRequestCacheKey('chat', 'students', classId);

export const studentService = {
    fetchStudentsList
};

function fetchStudentsList(classId) {
    return fetchWithCache({
        key: studentsListCacheKey(classId),
        ttlMs: STUDENTS_LIST_TTL_MS,
        loader: () => apiClient.get(`${api.chatmessage.fetchStudentsList}/${classId}`)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}
